import LoginView from "../pages/entrance/Login";
import SignupDetails from "../pages/entrance/SignupDetails";
import Signup from "../pages/entrance/SignupView";
import Username from "../pages/entrance/Username";
import SignUpVerification from "../pages/entrance/SignupVerification";
import ResetPassword from "../pages/passwordReset/ResetPassword";
import EnterOTP from "../pages/passwordReset/EnterOTP";
import EnterPassword from "../pages/passwordReset/EnterPassword";
import Profile from "../pages/profile/Profile";
import EditProfile from "../pages/profile/EditProfile";
import CreatePost from "../pages/posts/CreatePost";
import AddComCon from "../pages/posts/AddComCon";
import SelectCom from "../pages/posts/SelectCom";
import SelectConn from "../pages/posts/SelectConn";
import ViewPost from "../pages/posts/ViewPost";
import UserChat from "../pages/chat/UserChat";
import Chats from "../pages/chat/Chats";
import adminRoutes from "./admin.routes";
import communityAdminRoutes from "./communityAdmin.routes";
import Save from "../pages/save/Save";
import HomePage from "../pages/home/HomePage";
import CreateGroup from "../pages/group/CreateGroup";
import GroupInfo from "../pages/group/GroupInfo";
import CreateGroupDetails from "../pages/group/CreateGroupDetails";
import GroupManagement from "../pages/group/GroupManagement";
import { createBrowserRouter } from "react-router-dom";
import NewChat from "@pages/chat/NewChat";
import StreamManagement from "@pages/home/StreamManagement";
import AuthCallback from "@pages/entrance/AuthCallback";
import ReportForm from "@pages/report/ReportForm";
import AddResources from "@pages/group/AddResources";
import ContactForm from "@pages/contact/ContactUs";
import Blocked from "@pages/blocked/Blocked";
import Resources from "@pages/group/Resources";
import AddMembers from "@pages/group/AddMembers";
import EditGroup from "@pages/group/EditGroup";
import Search from "@pages/search/Search";
import Notifications from "@pages/notifications/Notifications";
import SelectGroup from "@pages/posts/SelectGroup";
import LoginDetails from "@pages/entrance/LoginDetails";
import LoginVerification from "@pages/entrance/LoginVerification";
import SelectTags from "@pages/posts/SelectTags";
import EditResource from "@pages/group/EditResource";
import UserAgreement from "@pages/UserAgreement";
import PrivacyPolicy from "@pages/PrivacyPolicy";
import RedirectToProfile from "@pages/profile/RedirectToProfile";
import SelectSignupCommunities from "@pages/entrance/SelectSignupCommunities";
import CommunityPage from "@pages/communities/CommunityPage";
import ProfileTagManagement from "@pages/tags/ProfileTagManagement";
import InviteFriends from "@pages/invite-friends/InviteFriends";
import GroupInviteExternal from "@pages/group/GroupInviteExternal";
import RootHooks from "../RootHooks";
import GroupEvents from "@pages/event/GroupEvents";
import CreateEvent from "@pages/event/CreateEvent";
import ViewEvent from "@pages/event/ViewEvent";
import CreateCarouselPost from "@pages/posts/CreateCarouselPost";

const routes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/stream",
    element: <HomePage />,
  },
  {
    path: "/login",
    element: <LoginView />,
  },
  {
    path: "/login-verification",
    element: <LoginVerification />,
  },
  {
    path: "/login-details",
    element: <LoginDetails />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/enter/person-details",
    element: <SignupDetails />,
  },
  {
    path: "/enter/select-communities",
    element: <SelectSignupCommunities />
  },
  {
    path: "/username",
    element: <Username />,
  },
  {
    path: "/link-sent",
    element: <SignUpVerification />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/enter-otp",
    element: <EnterOTP />,
  },
  {
    path: "/enter-password",
    element: <EnterPassword />,
  },
  {
    path: "/enter-password",
    element: <EnterPassword />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/profile/redirect/:userName",
    element: <RedirectToProfile />,
  },
  {
    path: "/profile/:userName",
    element: <Profile />,
  },
  {
    path: "/edit/profile",
    element: <EditProfile />,
  },
  {
    path: "/post/create/:id?",
    element: <CreatePost />,
  },
  {
    path: "/carousel-post/create/:id?",
    element: <CreateCarouselPost />,
  },
  {
    path: "/add-community-connection/:id?",
    element: <AddComCon />,
  },
  {
    path: "/select-community",
    element: <SelectCom />,
  },
  {
    path: "/select-group",
    element: <SelectGroup />,
  },
  {
    path: "/select-connection",
    element: <SelectConn />,
  },
  {
    path: "/post/:id",
    element: <ViewPost />,
  },
  {
    path: "/select-tags/:id?",
    element: <SelectTags />,
  },
  {
    path: "/user/chat/:receiverId",
    element: <UserChat />,
  },
  {
    path: "/chats",
    element: <Chats />,
  },
  {
    path: "/new/chat",
    element: <NewChat />,
  },
  {
    path: "/save",
    element: <Save />,
  },
  {
    path: "/blocked",
    element: <Blocked />,
  },
  {
    path: "/create/group/select/community",
    element: <CreateGroup />,
  },
  {
    path: "/edit/group",
    element: <EditGroup />,
  },
  {
    path: "/group/info/:id",
    element: <GroupInfo />,
  },
  {
    path: "/group/resources",
    element: <Resources />,
  },
  {
    path: "/group/resources/edit/:id",
    element: <EditResource />,
  },

  {
    path: "/create/group",
    element: <CreateGroupDetails />,
  },
  {
    path: "/group/management",
    element: <GroupManagement />,
  },
  {
    path: "/stream/management",
    element: <StreamManagement />,
  },
  {
    path: "/profile/tag-management",
    element: <ProfileTagManagement />,
  },
  {
    path: "/auth/callback/:token",
    element: <AuthCallback />,
  },
  {
    path: "/report",
    element: <ReportForm />,
  },
  {
    path: "/group/add/resources",
    element: <AddResources />,
  },
  {
    path: "/contact",
    element: <ContactForm />,
  },
  {
    path: "/group/add/member",
    element: <AddMembers />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
  {
    path: "/user-agreement",
    element: <UserAgreement />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/community/:id",
    element: <CommunityPage />,
  },
  {
    path: "/invite-friends",
    element: <InviteFriends />,
  },
  {
    path: "/group/email-invites/:groupId",
    element: <GroupInviteExternal />,
  },
  {
    path: "/group/:groupId/events",
    element: <GroupEvents />,
  },
  {
    path: "/group/:groupId/events/create",
    element: <CreateEvent />,
  },
  {
    path: "/event/:id",
    element: <ViewEvent />,
  },
  ...adminRoutes,
  ...communityAdminRoutes,

  // Any other route assumed to be username
  {
    path: "/:userName",
    element: <Profile />,
  },
]

const router = createBrowserRouter(
  routes.map((route) => ({
    ...route,
    element:
      <RootHooks>
        {route.element}
      </RootHooks>
  }))
);

export default router;
